import styled from 'styled-components';
import { Button } from '@figure/frontlib-gui';
import { Typography } from 'shared/components';
import { useRedirect } from 'shared/hooks';

const StyledButton = styled(Button)`
  margin-top: 30px;
`;

const CreditScoreDecline = () => {
  const { redirectToDashboard } = useRedirect();
  const handleDashboardClick = () => redirectToDashboard();

  return (
    <>
      <Typography.PageHeader>Thank you for your application.</Typography.PageHeader>
      <p>
        We'd love to serve you; however, your credit score is currently below our minimum
        requirement of 640. You are welcome to re-apply in the future as credit scores do fluctuate
        over time.
      </p>
      <p>
        Please visit your dashboard to view the adverse action notice. The notice provides the
        specific reasons for our decision, your credit score, and contact information for the
        consumer reporting agency that provided us your score.
      </p>

      <StyledButton large primary center onClick={handleDashboardClick}>
        Go to dashboard
      </StyledButton>
    </>
  );
};

export default CreditScoreDecline;
